export const RDD_CAN_CONFIGURE = 'RddCanConfigure';
export const RDD_CAN_READ = 'RddCanRead';